import { RoadmapTasks } from '../../../roadmap/components/RoadmapTasks';

export default function RoadmapTasksPage() {
    return <RoadmapTasks />;
}
